// src/App.js

import React from 'react';
import { Admin, Resource } from 'react-admin';
// --- 1. استيراد أدوات الترجمة ---
import polyglotI18nProvider from 'ra-i18n-polyglot';
import enTranslations from './i18n/en';
//import arTranslations from './i18n/ar';

// --- 2. استيراد المكونات والإعدادات اللازمة ---
import authProvider from './authProvider';
import dataProvider from './dataProvider';
import { Dashboard } from './Dashboard';
import { CustomLayout } from './CustomLayout'; // <-- تم التعديل: استخدام CustomLayout
import { SocketProvider } from './SocketContext'; 

// --- 3. استيراد جميع مكونات الموارد (Resources) ---
import { UserList, UserEdit } from './resources/users';
import { VerificationList } from './resources/verifications';
import { VerifiedUserList, VerifiedUserShow } from './resources/verifiedUsers';
import { VerifiedCarList } from './resources/verifiedCars';
import { RideList, RideShow } from './resources/rides';
import { ReportList, ReportEdit } from './resources/reports'; // <-- **تم التعديل**: استيراد ReportEdit
import { SupportChatList, SupportChatShow } from './resources/supportChats';
import { ConfigurationEdit } from './resources/Configuration';
import { PromoCodeList, PromoCodeCreate } from './resources/PromoCodes'; // سيتم إنشاؤها في الخطوة التالية
import { ChatList, ChatShow } from './resources/chats'; // <-- استيراد جديد

import AdminNotificationListener from './components/AdminNotificationListener';

const i18nProvider = polyglotI18nProvider(
    () => enTranslations, // استخدم الإنجليزية دائمًا
    'en' // اللغة الافتراضية
);

const App = () => (
  <SocketProvider>
    <Admin 
      dataProvider={dataProvider}
      authProvider={authProvider} 
      dashboard={Dashboard} 
      layout={CustomLayout} // <-- تم التعديل: استخدام CustomLayout
      i18nProvider={i18nProvider} // <-- **الإضافة الجديدة**: تفعيل الترجمة
    >
      {/* موارد وهمية للاتصالات الداخلية */}
      <Resource name="unread-counts" /> 
      <Resource name="debug/grant-premium" />
      {/* ملاحظة: مسار الحظر هو 'users/:id/ban'
        سيتم استدعاؤه باستخدام dataProvider.create('users/USER_ID/ban', ...)
        لذا لا نحتاج لتعريف مورد (Resource) منفصل له
      */}

      {/* الموارد الفعلية */}
      <Resource name="users" list={UserList} edit={UserEdit} />
      <Resource name="verifications" list={VerificationList} options={{ label: 'Verifications' }} />
      <Resource name="verified-users" list={VerifiedUserList} show={VerifiedUserShow} />
      <Resource name="verified-cars" list={VerifiedCarList} />
      <Resource name="rides" list={RideList} show={RideShow} />
      <Resource name="reports" list={ReportList} edit={ReportEdit} /> {/* <-- **تم التعديل**: إضافة edit */}
      <Resource name="chats" list={ChatList} show={ChatShow} />
      <Resource name="support-chats" list={SupportChatList} show={SupportChatShow} />
      <Resource name="config" edit={ConfigurationEdit} />
      <Resource name="promo-codes" list={PromoCodeList} create={PromoCodeCreate} />

      {/* موارد مخفية تستخدم للربط (مثل في تفاصيل الرحلة) */}
      <Resource name="bookings" /> 
      <Resource name="cars" />

      <AdminNotificationListener />

    </Admin>
  </SocketProvider>
);

export default App;